import { SortableColumnDirective } from './sortable-column.directive';

export const directives = [SortableColumnDirective];

export * from './sortable-column.directive';
